import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoDataSourceBase from '../KendoDataSourceBase'

import Schema from './Schema'
import Filter from '../KendoDataSourceBase/Filter'
import Group from '../KendoDataSourceBase/Group'
import Sort from '../KendoDataSourceBase/Sort'
import Transport from '../KendoDataSourceBase/Transport'

export default {
    mixins: [
        KendoBaseComponent,
        KendoDataSourceBase,
        Schema,
        Filter,
        Group,
        Sort,
        Transport
    ],
    mounted () {
        this.kendoDataSource = new kendo.data.HierarchicalDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.HierarchicalDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoHierarchicalDataSource/KendoHierarchicalDataSourceMixin.js